module.exports = __webpack_public_path__ + "img/secullum-icon.598e5a29.svg";